import { PhoneFormatter } from 'field-kit';
import { parsePhoneNumber } from 'libphonenumber-js';
//
// Courtesy of rice@ who worked on the formatting for android
//
// I followed the Japanese National Numbering Plan:
// http://www.itu.int/dms_pub/itu-t/oth/02/02/T020200006D0001PDFE.pdf.
// Generally landlines have 10 digits, and mobiles/ip phones/other non-landline
// services have 11 digits (both including a leading 0 to indicate long
// distance). The tricky part is that the geographic prefixes have variable
// length, with short codes for the major cities (as little as 1 digit)  and
// longer codes for less populous areas (as many as 4 digits).

// Basically I boiled the list of prefixes down to a set of regexes, one for
// each prefix length, each with a corresponding hyphenation pattern. You should
// attempt to match the longest prefixes first, for example a number 04992xxxxx
// would be formatted as 04992-x-xxxx rather than 04-992x-xxxx . If nothing
// matches, you should probably allow any 11-digit string.

// // 0[346]-xxxx-xxxx
// oneDigitPrefixes = "[346]";
// // 0xx-xxx-xxxx
// twoDigitPrefixes = "(1[157-9]|2[2-9]|4[2-9]|5[2-589]|7[235-9]|8[2-9]|9[1-35-9])";
// // 0xxx-xx-xxxx
// threeDigitPrefixes = "(12[03-6]|13[3-9]|14[2-6]|15[2-8]|16[2-7]|17[02-9]|18[02-7]|"
//       + "19[1-578]|22[03-689]|23[3-578]|24[1-46-8]|25[04-9]|26[013-9]|27[046-9]|28[02-57-9]|"
//       + "29[13-79]|42[28]|43[689]|46[03567]|47[05689]|480|49[345]|53[1-36-9]|54[4578]|55[013-8]|"
//       + "56[1-9]|57[02-8]|58[14-7]|59[4-9]|72[15]|73[5-9]|74[02-9]|76[13-8]|77[0-4689]|79[014-9]|"
//       + "800|82[034679]|83[3-8]|84[5678]|85[2-9]|86[35-9]|87[579]|88[03-579]|89[2-8]|9[23]0|"
//       + "94[02-46-9]|95[024-679]|96[4-9]|97[2-47-9]|98[02-7]|99[03-7])";
// // 0xxxx-x-xxxx
// fourDigitPrefixes = "(1267|137[247]|139[278]|145[67]|1466|1547|1558|1564|158[67]|"
//       + "163[245]|1648|165[4568]|499[2468]|5769|5979|7468|838[78]|8396|8477|851[24]|8636|"
//       + "9496|9802|991[23]|9969)";
// // Non-geographic services (e.g., mobile) (note: 11 digits total)
// // 0[25-9]0-xxxx-xxxx
// nonGeographicPrefixes = "[25-9]0";

// 24-535-1111
const LANDLINE_WITHOUT_ZERO = {
  delimiterMap: {
    2: '-',
    6: '-'
  },
  maximumLength: 11
};

// 024-535-1111
const LANDLINE = {
  delimiterMap: {
    3: '-',
    7: '-'
  },
  maximumLength: 12
};

// +81 24-535-1111
const LANDLINE_WITH_COUNTRY_CODE = {
  delimiterMap: {
    3: ' ',
    6: '-',
    10: '-'
  },
  maximumLength: 15
};

// 80-1234-5678
const MOBILE_WITHOUT_ZERO = {
  delimiterMap: {
    2: '-',
    7: '-'
  },
  maximumLength: 12
};

// 080-1234-5678
const MOBILE = {
  delimiterMap: {
    3: '-',
    8: '-'
  },
  maximumLength: 13
};

// +81 80-1234-5678
const MOBILE_WITH_COUNTRY_CODE = {
  delimiterMap: {
    3: ' ',
    6: '-',
    11: '-'
  },
  maximumLength: 16
};
export default class JapanesePhoneFormatter extends PhoneFormatter {
  format(text) {
    if (!text || text.length === 0) {
      return super.format(text);
    }
    if (text.startsWith('81')) {
      text = `+${text}`;
    }
    try {
      const phoneNumber = parsePhoneNumber(text, 'JP');
      text = phoneNumber.formatNational();
    } catch {
      return text;
    }
    return text;
  }
  guessFormatFromText(text) {
    if (!text) {
      super.guessFormatFromText(text);
      return;
    }
    if (text.startsWith('0') && !['5', '7', '8', '9'].includes(text[1])) {
      this.delimiterMap = LANDLINE.delimiterMap;
      this.maximumLength = LANDLINE.maximumLength;
    } else if (text.startsWith('+81') && ['5', '7', '8', '9'].includes(text[4]) && text[5] === '0') {
      this.delimiterMap = MOBILE_WITH_COUNTRY_CODE.delimiterMap;
      this.maximumLength = MOBILE_WITH_COUNTRY_CODE.maximumLength;
    } else if (text.startsWith('+8')) {
      this.delimiterMap = LANDLINE_WITH_COUNTRY_CODE.delimiterMap;
      this.maximumLength = LANDLINE_WITH_COUNTRY_CODE.maximumLength;
    } else if (text.startsWith('0') && ['5', '7', '8', '9'].includes(text[1])) {
      this.delimiterMap = MOBILE.delimiterMap;
      this.maximumLength = MOBILE.maximumLength;
    } else if (['5', '7', '8', '9'].includes(text[0])) {
      this.delimiterMap = MOBILE_WITHOUT_ZERO.delimiterMap;
      this.maximumLength = MOBILE_WITHOUT_ZERO.maximumLength;
    } else {
      this.delimiterMap = LANDLINE_WITHOUT_ZERO.delimiterMap;
      this.maximumLength = LANDLINE_WITHOUT_ZERO.maximumLength;
    }
  }
}